import { render, staticRenderFns } from "./Acknowledgement.vue?vue&type=template&id=7ca4dab5&scoped=true&"
import script from "./Acknowledgement.vue?vue&type=script&lang=js&"
export * from "./Acknowledgement.vue?vue&type=script&lang=js&"
import style0 from "./Acknowledgement.vue?vue&type=style&index=0&id=7ca4dab5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca4dab5",
  null
  
)

export default component.exports